<template>
  <div>
    <h1>Ghost CMS</h1>
    <table>
      <tr>
        <th style=" color: #fff;background: #333">ID</th>
        <th style=" color: #fff;background: #333">TITLE</th>
        <th style=" color: #fff;background: #333">URL</th>
      </tr>

      <tr></tr>
      <tr v-for="(post, index) in posts" :key="index">
        <td style=" color: #333;background: #fff">{{ post.id }}</td>
        <td style=" color: #333;background: #fff">{{ post.title }}</td>
        <td style=" color: #333;background: #fff">
          <a :href="post.url">{{ post.url }}</a>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      posts: [],
    }
  },
  mounted() {
    this.axios({
      method: "get",
      url: `${siteConfig.ghostURL}ghost/api/v2/content/posts/?key=${siteConfig.ghostKey}&formats=html&page=1&limit=5000&order=published_at%20desc&fields=id,title,url`,
    }).then(res => {
      this.posts = res.data.posts.map(item => ({
        id: item.id,
        title: item.title,
        url: item.url,
      }))
    })
  },
}
</script>

<style scoped></style>
